<p-dialog [(visible)]="displayNewBill" [modal]="true" [responsive]="true" [closable]="false" [style]="{width: '80vw'}"
    (onHide)="resetDialog()">
    <ng-template pTemplate="header">
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
            <h5 class="p-mb-0">{{mode == 'VIEW' ? 'View Bill' : mode == 'COPY' ? 'Copy Bill' : 'Edit Bill'}}</h5>
            <div style="display: flex; align-items: center;">
                <div>
                    <strong [ngClass]="'status-open'" *ngIf="statementMessege">{{statementMessege}}</strong>
                </div>

            </div>
            <div *ngIf="mode == 'VIEW' && !savedBill?.isVoided && savedBill?.openBalance > 0" pTooltip="Edit Bill"
                tooltipPosition="top" (click)="openBillEditor()" class="btnBars" style="margin-left: auto;">
                <i class="pi pi-pencil"></i>
            </div>
        </div>
    </ng-template>
    <form [formGroup]="billForm">
        <div class="header">
            <div class="p-grid">
                <div class="p-col-12 p-lg-6 p-pb-0 p-d-flex">
                    <span style="color: red;" class="p-mr-2">*</span>
                    <div style="flex-grow: 1;">
                        <p-dropdown [disabled]="true" [options]="allVendorsDD" [filter]="true" optionLabel="name"
                            placeholder="Select Vendor" appendTo="body"
                            (onChange)="getSelectedVendorDetails(billForm.controls['vendorId'].value?.id)"
                            class="vendorClass" formControlName="vendorId"></p-dropdown>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-field p-formgrid p-grid" *ngIf="billForm.controls['vendorId'].value">
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 135px;">
                        <h6 class="p-mb-0">Vendor Information</h6>
                        <p class="p-mb-0 p-d-flex"
                            *ngIf="billTemplate && billTemplate.labels_billaddress  && billTemplate.labels_billaddress[0]?.isChecked">
                            {{billForm.controls['vendorId']?.value?.name}}
                            <span *ngIf="vendorDetails?.vendorAddresses?.length>1" pTooltip="Edit Vendor Address"
                                (click)="onChangeVendor(vendorDetails,'edit')" class="p-ml-4 btnBars">
                                <i class="pi pi-pencil"></i>
                            </span>
                        </p>
                        <p class="p-mb-0"
                            *ngIf="billTemplate && billTemplate.labels_billaddress  && billTemplate.labels_billaddress[1]?.isChecked">
                            {{ordersVendorAddrNew}}<span *ngIf="ordersVendorAddrNew !== ''">,</span>
                        </p>
                        <p class="p-mb-0"
                            *ngIf="billTemplate && billTemplate.labels_billaddress  && billTemplate.labels_billaddress[2]?.isChecked">
                            {{ordersVendorCityNew}}<span *ngIf="ordersVendorCityNew !== ''">, </span>
                            {{ordersVendorStateNew}}
                            <span *ngIf="ordersVendorStateNew !== ''">, </span> {{ordersVendorCountryNew}}
                            <span *ngIf="ordersVendorCountryNew !== ''">, </span> {{ordersVendorZipcodeNew}}
                        </p>
                        <p class="p-mb-0 p-d-flex"
                            *ngIf="billTemplate && billTemplate.labels_billaddress  && billTemplate.labels_billaddress[3]?.isChecked">
                            {{ordersVendorContactNew}}
                            <span *ngIf="vendorDetails?.vendorContacts?.length>1" pTooltip="Edit Vendor Contact"
                                (click)="changeVendorContact()" class="p-ml-4 btnBars">
                                <i class="pi pi-pencil"></i>
                            </span>
                        </p>
                        <p class="p-mb-0"
                            *ngIf="billTemplate && billTemplate.labels_billaddress  && billTemplate.labels_billaddress[4]?.isChecked">
                            {{ordersVendorPhoneNew}}</p>
                    </div>
                </div>
            </div>
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 135px;">
                        <h6 class="p-mb-0">Shipping<span style="color: red;">*</span>
                            <!-- <span class="btnBars p-ml-6" style="position: relative;" (click)="op.toggle($event)">
                                <i class="pi pi-map-marker"></i>
                            </span> -->
                        </h6>
                        <p-overlayPanel #op styleClass="inlinePanel panel-in-dialog">
                            <ng-template pTemplate>
                                <ul>
                                    <ng-container *ngFor="let c of allLocationsDD">
                                        <li (click)="getShipAddress(c)">{{c.customName}}
                                            <a *ngIf="c.address">
                                                {{c.address.streetAddress1 ? c.address.streetAddress1 :
                                                (c.address.streetAddress2 ? c.address.streetAddress2 : null)}}
                                                <span
                                                    *ngIf="c.address.city && (c.address.streetAddress1 || c.address.streetAddress2)">,</span>
                                                {{c.address.city ? c.address.city.name : null}}<span
                                                    *ngIf="c.address.state">,</span>
                                                {{c.address.state ? c.address.state.name : null}}<span
                                                    *ngIf="c.address.country">,</span>
                                                {{c.address.country ? c.address.country.name : null}}<span
                                                    *ngIf="c.address.zipCode">,</span>
                                                {{c.address.zipCode ? c.address.zipCode : null}}
                                            </a>
                                        </li>
                                    </ng-container>
                                </ul>
                            </ng-template>
                        </p-overlayPanel>
                        <p class="p-mb-0"
                            *ngIf="billTemplate && billTemplate.labels_shipaddress  && billTemplate.labels_shipaddress[0]?.isChecked && shipAddress">
                            {{appValue?.user?.organizationName}}</p>
                        <p class="p-mb-0">{{shipAddress?.customName}}</p>
                        <p class="p-mb-0"
                            *ngIf="billTemplate && billTemplate.labels_shipaddress  && billTemplate.labels_shipaddress[1]?.isChecked">
                            {{shipAddress?.address?.streetAddress1 ? shipAddress?.address?.streetAddress1 :
                            (shipAddress?.address?.streetAddress2 ? shipAddress?.address?.streetAddress2 : null)}}
                            <span
                                *ngIf="shipAddress?.address?.city && (shipAddress?.address?.streetAddress1 || shipAddress?.address?.streetAddress2)">,</span>
                        </p>
                        <p class="p-mb-0"
                            *ngIf="billTemplate && billTemplate.labels_shipaddress  && billTemplate.labels_shipaddress[2]?.isChecked">
                            {{shipAddress?.address?.city ? shipAddress?.address?.city?.name : null}}<span
                                *ngIf="shipAddress?.address?.state">,</span> {{shipAddress?.address?.state ?
                            shipAddress?.address?.state?.name : null}}<span
                                *ngIf="shipAddress?.address?.country">,</span> {{shipAddress?.address?.country ?
                            shipAddress?.address?.country?.name : null}}<span
                                *ngIf="shipAddress?.address?.zipCode">,</span> {{shipAddress?.address?.zipCode ?
                            shipAddress?.address?.zipCode : null}}
                        </p>
                        <p class="p-mb-0"
                            *ngIf="billTemplate && billTemplate.labels_shipaddress  && billTemplate.labels_shipaddress[3]?.isChecked && shipAddress">
                            {{shipAddress?.contactPersonName}}</p>
                        <p class="p-mb-0"
                            *ngIf="billTemplate && billTemplate.labels_shipaddress  && billTemplate.labels_shipaddress[4]?.isChecked && shipAddress">
                            {{shipAddress?.phoneNo}}
                        </p>
                        <p class="p-mb-0"></p>
                    </div>
                </div>
            </div>
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 135px;">
                        <div class="p-mb-2"> Bill No.: {{ savedBill?.number }} </div>
                        <div class="p-mb-2"
                            *ngIf="billTemplate && billTemplate.labels_misc  && billTemplate.labels_misc[0]?.isChecked">
                            {{billTemplate && billTemplate.labels_misc && billTemplate.labels_misc[0]?.labelname}}:
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                (onSelect)="calculateDueDate()" formControlName="billDate" placeholder="mm/dd/yyyy"
                                dateFormat="mm/dd/yy" [minDate]="minDate" [maxDate]="maxDate"
                                class="inline"></p-calendar>
                        </div>
                        <div class="p-mb-2 p-d-flex p-ai-center p-flex-wrap" *ngIf="isAllowPostingPeriod">
                            <label style="min-width: 120px;">Posting Period<span style="color: red">*</span>:</label>
                            <div style="flex: 1; max-width: 175px; margin-left: 0;">
                                <app-posting-period-selector [transactionDate]="billForm?.controls?.billDate?.value"
                                    [moduleName]="'Bill'" [selectedPostingPeriod]="currentPostingPeriodInfo"
                                    [isViewMode]="mode == 'VIEW'" (postingInfoChange)="onPostingInfoChange($event)">
                                </app-posting-period-selector>
                            </div>
                        </div>
                        <div class="p-mb-2"
                            *ngIf="billTemplate && billTemplate.labels_misc  && billTemplate.labels_misc[2]?.isChecked">
                            {{billTemplate && billTemplate.labels_misc && billTemplate.labels_misc[2]?.labelname}}:
                            <p-inputNumber inputId="minmaxfraction" mode="decimal" [minFractionDigits]="length"
                                [maxFractionDigits]="length" class="small inlineDD"
                                formControlName="amountDue"></p-inputNumber>
                        </div>
                        <div class="p-mb-2"
                            *ngIf="billTemplate && billTemplate.labels_misc  && billTemplate.labels_misc[4]?.isChecked">
                            {{billTemplate && billTemplate.labels_misc && billTemplate.labels_misc[4]?.labelname}}:
                            {{savedBill?.currencyUnit?.symbol}} {{savedBill?.openBalance | customNumberFormat: length
                            }}
                        </div>
                        <div class="p-mb-2"
                            *ngIf="billTemplate && billTemplate.labels_misc  && billTemplate.labels_misc[3]?.isChecked">
                            {{billTemplate && billTemplate.labels_misc && billTemplate.labels_misc[3]?.labelname}}
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" [minDate]="minimumDate" class="inline"
                                formControlName="dueDate"></p-calendar>
                        </div>
                        <p class="p-mb-0">Bill Status: {{savedBill?.billStatus}}</p>
                        <p class="p-mb-0">Received By: {{savedBill?.createdByUser}}</p>
                        <div class="p-mb-2"
                            *ngIf="billTemplate && billTemplate.labels_misc  && billTemplate.labels_misc[1]?.isChecked">
                            {{billTemplate && billTemplate.labels_misc && billTemplate.labels_misc[1]?.labelname}}:
                            <input type="text" pInputText class="small inlineDD" formControlName="referenceNo">
                        </div>
                        <div class="p-d-flex p-mb-2">
                            Currency: {{savedBill?.currencyUnit?.code}}
                        </div>
                        <div class="p-d-flex" *ngIf="(baseCurrency?.currencyId!==vendorDetails?.currencyId)">
                            1 {{baseCurrency?.code}} = {{vendorExchangeRate}} {{vendorDetails?.currencyUnit?.code}}
                            <span *ngIf="mode != 'VIEW'" class="btnBars" (click)="showEditExchangeRate($event)">
                                <i class="pi pi-pencil"></i>
                            </span>
                        </div>
                        <p-overlayPanel #editCurrency [showCloseIcon]="true"
                            styleClass="no-padding custom-overlay-header" [style]="{width: '300px'}">
                            <div class="panel-header">
                                <h5 class="p-mb-0">Edit Exchange Rate</h5>
                            </div>
                            @if(vendorDetails){
                            <app-edit-exchangerate [vendorDetails]="vendorDetails" [orgCurrency]="orgCurrency"
                                [vendorCurrencyExchangeRate]="vendorExchangeRate"
                                (closeDialog)="closeCurrencyDialog($event)"></app-edit-exchangerate>
                            }
                        </p-overlayPanel>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-field p-formgrid p-grid" *ngIf="billTemplate?.labels_section?.length>0">
            <div class="p-col" *ngIf="billTemplate.labels_section[0]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">{{billTemplate.labels_section[0]?.labelname}}</h6>
                    <p class="p-mb-0">
                        <p-dropdown [options]="vendorPaymentTermsDD" class="small inlineNormalDD"
                            formControlName="paymentTermId" optionLabel="paymentMethodTerm"
                            placeholder="Select Payment Term" [showClear]="true" [filter]="true" appendTo="body"
                            (onChange)="calculateDueDate()"></p-dropdown>
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="billTemplate.labels_section[1]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">{{billTemplate.labels_section[1]?.labelname}}</h6>
                    <p class="p-mb-0">
                        <p-dropdown [options]="vendorPaymentMethodsDD" class="small inlineNormalDD"
                            formControlName="paymentMethodId" optionLabel="paymentMethodMethod"
                            placeholder="Select Payment Method" [showClear]="true" [filter]="true"
                            appendTo="body"></p-dropdown>
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="billTemplate.labels_section[2]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">{{billTemplate.labels_section[2]?.labelname}}</h6>
                    <p class="p-mb-0">
                        <p-dropdown [options]="allShippingTerms" class="small inlineNormalDD" optionLabel="name"
                            placeholder="Select Shipping Terms" [showClear]="true" [filter]="true" appendTo="body"
                            formControlName="shippingTermId"></p-dropdown>
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="billTemplate.labels_section[3]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">{{billTemplate.labels_section[3]?.labelname}}</h6>
                    <p class="p-mb-0">
                        <p-dropdown [options]="vendorShippingMethodsDD" class="small inlineNormalDD"
                            formControlName="shippingMethodId" optionLabel="shippingMethodName"
                            placeholder="Select Shipping Method" appendTo="body"></p-dropdown>
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="billTemplate.labels_section[4]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">{{billTemplate.labels_section[4]?.labelname}}.</h6>
                    <p class="p-mb-0">
                        <p-dropdown [options]="productOwner" class="small inlineNormalDD" formControlName="userId"
                            optionLabel="name" placeholder="Select Sales Rep" appendTo="body" [showClear]="true"
                            [filter]="true" optionValue="id"></p-dropdown>
                    </p>
                </div>
            </div>
        </div>
        <p-tabView class="custom-header" [(activeIndex)]="index">
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="p-d-flex p-jc-between" style="width: 100%;">
                        <span>Expenses</span>
                        <span>{{vendorDetails?.currencyUnit?.symbol}} {{amountExpense | customNumberFormat:
                            length}}</span>
                    </div>
                </ng-template>
                <p-table [value]="expenses" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{billTemplate && billTemplate.labels_expenses &&
                                billTemplate.labels_expenses[0]?.labelname}}
                            </th>
                            <th>{{billTemplate && billTemplate.labels_expenses &&
                                billTemplate.labels_expenses[1]?.labelname}}
                            </th>
                            <th>{{billTemplate && billTemplate.labels_expenses &&
                                billTemplate.labels_expenses[2]?.labelname}}
                            </th>
                            <th style="width: 120px;" *ngIf="mode != 'VIEW'">Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-account let-index="rowIndex">
                        <tr>
                            <td>{{account.financialAccountId?.label}}</td>
                            <td>{{vendorDetails?.currencyUnit?.symbol}} {{account.amount |customNumberFormat: length }}
                            </td>
                            <td>{{account.memo}}</td>
                            <td class="action" *ngIf="mode != 'VIEW'">
                                <div class="btnBars p-mr-0" (click)="editExpense(account)">
                                    <i class="pi pi-pencil"></i>
                                </div>
                                <div class="btnBars p-mr-0" (click)="removeItem(index,'expense')">
                                    <i class="pi pi-trash"></i>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="7" class="p-text-center">
                                No expense account found.
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-tabPanel>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="p-d-flex p-jc-between" style="width: 100%;">
                        <span>Items</span>
                        <span>{{vendorDetails?.currencyUnit?.symbol}} {{amountItem |customNumberFormat: length }}</span>
                    </div>
                </ng-template>
                <!-- <div class="p-field p-formgrid p-grid header">
                    <div class="p-col-3"></div>
                    <div class="p-col-6">
                        <input type="text" placeholder="Search by Item No., Barcode..." [(ngModel)]="searchValue" [ngModelOptions]="{standalone: true}"
                        [disabled]="!billForm.controls['vendorId']?.value" pInputText (keydown.enter)="onCompleteSearchProduct($event)">
                    </div>
                </div> -->
                <p-table [value]="items" responsiveLayout="scroll" dataKey="productId">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 5rem"></th>
                            <th>PO No.</th>
                            <th>{{billTemplate && billTemplate.labels_table && billTemplate.labels_table[0]?.labelname}}
                            </th>
                            <th>{{billTemplate && billTemplate.labels_table && billTemplate.labels_table[1]?.labelname}}
                            </th>
                            <th>{{billTemplate && billTemplate.labels_table && billTemplate.labels_table[2]?.labelname}}
                            </th>
                            <th>{{billTemplate && billTemplate.labels_table && billTemplate.labels_table[3]?.labelname}}
                            </th>
                            <th *ngIf="billTemplate?.labels_table[6]?.isChecked">{{billTemplate &&
                                billTemplate.labels_table && billTemplate.labels_table[6]?.labelname}}
                            </th>
                            <th *ngIf="billTemplate?.labels_table[5]?.isChecked">{{billTemplate &&
                                billTemplate.labels_table && billTemplate.labels_table[5]?.labelname}}
                            </th>
                            <th>{{billTemplate && billTemplate.labels_table && billTemplate.labels_table[4]?.labelname}}
                            </th>
                            <th>Serial No.</th>
                            <th style="width: 120px;" *ngIf="mode != 'VIEW'">Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-index="rowIndex" let-expanded="expanded">
                        <tr>
                            <td>
                                <button type="button" pButton pRipple [pRowToggler]="product"
                                    class="p-button-text p-button-rounded p-button-plain"
                                    *ngIf="product.products?.length>0"
                                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                            </td>
                            <td>{{product.poNo ?? 'N/A'}}</td>
                            <td>{{product.itemNo}}</td>
                            <td pEditableColumn class="action">
                                <p-cellEditor style="word-break: break-word;">
                                    <ng-template pTemplate="input">
                                        <textarea rows="1" pInputTextarea autoResize="autoResize"
                                            [ngModelOptions]="{standalone: true}" [(ngModel)]="product.description"
                                            style="width: 100%;"
                                            (keydown.enter)="onEnterDownStopPropagation($event)"></textarea>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{product.description?.length > 55 ? (product.description | slice: 0:55) +
                                        "...": product.description}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td pEditableColumn class="action">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <p-inputNumber [min]="1" [ngModelOptions]="{standalone: true}"
                                            [(ngModel)]="product.availabel" mode="decimal"
                                            [minFractionDigits]="product.uomCategory ? 0 : qtyDecimal"
                                            [maxFractionDigits]="product.uomCategory ? 0 : qtyDecimal"
                                            (focusout)="calculateSubTotal(product,product.availabel,product.price)"></p-inputNumber>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{product.availabel | customNumberFormat: qtyDecimal}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td pEditableColumn class="action">
                                <p-cellEditor *ngIf="product.typeId!=4">
                                    <ng-template pTemplate="input">
                                        <p-inputNumber [min]="0.01" [ngModelOptions]="{standalone: true}" mode="decimal"
                                            [minFractionDigits]="length" [maxFractionDigits]="length"
                                            [(ngModel)]="product.price"
                                            (focusout)="calculateSubTotal(product,product.availabel,product.price)"></p-inputNumber>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{vendorDetails?.currencyUnit?.symbol}} {{product.price |customNumberFormat:
                                        length }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>{{vendorDetails?.currencyUnit?.symbol}} {{product.cost |customNumberFormat: length }}
                            </td>
                            <td *ngIf="billTemplate?.labels_table[5]?.isChecked" class="action">
                                <div class="p-d-flex">
                                    <span class="btnBars" (click)="openTax(product)"
                                        *ngIf="mode != 'VIEW' && product?.productSubTax?.length == 0">
                                        <i class="pi pi-plus-circle"></i>
                                    </span>
                                    <span class="btnBars" (click)="openTax(product)"
                                        *ngIf="mode != 'VIEW' && product?.productSubTax?.length > 0">
                                        <i class="pi pi-bars"></i>
                                    </span>
                                    {{vendorDetails?.currencyUnit?.symbol}} {{ product.taxAmount ?
                                    (product.taxAmount
                                    | customNumberFormat: length) : (0 | customNumberFormat: length) }}
                                </div>
                            </td>
                            <td>{{vendorDetails?.currencyUnit?.symbol}} {{product.lineTotal | customNumberFormat: length
                                }}
                            </td>
                            <td pEditableColumn class="action">
                                <span class="btnBars p-mt-2 badge" *ngIf="product.trackingEnabled"
                                    (click)="openScanInfo(product)">
                                    <i class="pi pi-th-large" pBadge value="{{product?.billOrderSerialDetail ? product?.billOrderSerialDetail?.length:
                                    product.serialCount}}" severity="warning"></i>
                                </span>
                            </td>
                            <td class="action" *ngIf="mode != 'VIEW'">
                                <div class="btnBars p-mr-0" (click)="removeItem(index,'item')">
                                    <i class="pi pi-trash"></i>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="rowexpansion" let-product>
                        <!-- bundle items -->
                        <tr *ngFor="let bundle of product.products" class="bundleRow">
                            <td></td>
                            <td>{{bundle.poNo ?? 'N/A'}}</td>
                            <td>
                                {{bundle.itemNo}}
                            </td>
                            <td>
                                {{bundle.description?.length > 55 ? (bundle.description | slice: 0:55) + "...":
                                bundle.description}}
                            </td>
                            <td pEditableColumn class="action">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <p-inputNumber [min]="1" (keypress)="utilService.isNumberKey($event)"
                                            [ngModelOptions]="{standalone: true}" [(ngModel)]="bundle.availabel"
                                            (focusout)="calculateBundlePrice(product,bundle)"></p-inputNumber>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{bundle.availabel}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td pEditableColumn class="action">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <p-inputNumber [min]="0.01" [ngModelOptions]="{standalone: true}" mode="decimal"
                                            [minFractionDigits]="length" [maxFractionDigits]="length"
                                            [(ngModel)]="bundle.price"
                                            (focusout)="calculateBundlePrice(product,bundle)"></p-inputNumber>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{bundle.price |customNumberFormat: length| currencySymbol}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                {{bundle.cost |customNumberFormat: length| currencySymbol}}
                            </td>
                            <td>
                                <span class="btnBars p-mt-2 badge" *ngIf="bundle.trackingEnabled"
                                    (click)="openScanInfo(bundle,product)">
                                    <i class="pi pi-th-large" pBadge value="{{bundle?.billOrderBundleSerialDetail ? bundle?.billOrderBundleSerialDetail?.length: 
                                    bundle.serialCount}}" severity="warning"></i>
                                </span>
                            </td>
                            <td class="action"></td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="7" class="p-text-center">
                                No items found.
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <tr>
                            <td></td>
                            <td>Total</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td *ngIf="billTemplate?.labels_table[6]?.isChecked">{{vendorDetails?.currencyUnit?.symbol}} {{subTotal | customNumberFormat: length }}</td>
                            <td *ngIf="billTemplate?.labels_table[5]?.isChecked">
                                {{vendorDetails?.currencyUnit?.symbol}} {{tax | customNumberFormat: length }}
                            </td>
                            <td>{{vendorDetails?.currencyUnit?.symbol}} {{lineTotal | customNumberFormat: length }}</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr
                            *ngIf="billTemplate && billTemplate.labels_footer  && billTemplate.labels_footer[1]?.isChecked">
                            <td [attr.colspan]="(billTemplate?.labels_table[5]?.isChecked ? 8 : 7)" class="p-text-right">{{billTemplate &&
                                billTemplate.labels_footer &&
                                billTemplate.labels_footer[1]?.labelname}}
                            </td>
                            <td colspan="3">
                                <div class="p-inputgroup">
                                    <span>{{vendorDetails?.currencyUnit?.symbol}}</span>
                                    <p-inputNumber [min]="0" mode="decimal" [(ngModel)]="shippingAmount" [disabled]="mode == 'VIEW'"
                                        (focusout)="findsum()" [minFractionDigits]="length" [maxFractionDigits]="length"
                                        class="footer-input" [ngModelOptions]="{standalone: true}">
                                    </p-inputNumber>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td [attr.colspan]="(billTemplate?.labels_table[5]?.isChecked ? 8 : 7)" class="action">
                                <div class="p-d-flex" style="flex-direction: row-reverse;">
                                    <div class="p-d-flex">
                                        <p-dropdown placeholder="Select" [options]="allDiscounts"
                                            (onChange)="findsum(false)" class="footer-dd" [disabled]="mode == 'VIEW'"
                                            optionLabel="additionalDescription" appendTo="body"
                                            [(ngModel)]="selectedValueOption"
                                            [ngModelOptions]="{standalone: true}"></p-dropdown>
                                        <p-inputNumber [(ngModel)]="discountAmount" (focusout)="findsum(true)"
                                            mode="decimal" [min]="0" [minFractionDigits]="length"
                                            [maxFractionDigits]="length"
                                            [disabled]="mode == 'VIEW' ||selectedValueOption?.type?.name == 'Percentage' || selectedValueOption?.type?.name == '%'"
                                            [max]="selectedValueOption?.description=='%'?99.99:subTotal"
                                            class="footer-input" [ngModelOptions]="{standalone: true}"></p-inputNumber>
                                    </div>
                                    <span class="p-mr-3 p-pt-1">
                                        {{billTemplate && billTemplate.labels_footer &&
                                        billTemplate.labels_footer[2]?.labelname}}
                                    </span>
                                </div>
                            </td>
                            <td colspan="3">{{vendorDetails?.currencyUnit?.symbol}} {{ discount |customNumberFormat:
                                length }}</td>
                        </tr>
                        <tr *ngIf="footerTaxEnabled">
                            <td></td>
                            <td class="action" [attr.colspan]="6">
                                <div class="p-d-flex" style="flex-direction: row-reverse">
                                    <span class="p-mr-3 p-pt-1">
                                        {{ billTemplate?.labels_footer[4]?.labelname }}
                                        <span class="btnBars" *ngIf="mode != 'VIEW'" (click)="openFooterTax()">
                                            <i class="pi pi-plus-circle"></i>
                                        </span>
                                    </span>
                                </div>
                            </td>
                            <td colspan="3">{{vendorDetails?.currencyUnit?.symbol}} {{ tax | customNumberFormat: length }}</td>
                        </tr>
                        <tr>
                            <td [attr.colspan]="(illTemplate?.labels_table[5]?.isChecked ? 8 : 7)" class="p-text-right">{{billTemplate &&
                                billTemplate.labels_footer &&
                                billTemplate.labels_footer[3]?.labelname}}
                            </td>
                            <td colspan="3">{{vendorDetails?.currencyUnit?.symbol}} {{amountItem |customNumberFormat:
                                length }}</td>
                        </tr>
                    </ng-template>
                </p-table>

            </p-tabPanel>
            <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
                <ng-template pTemplate="header">
                    <span class="btnBars p-mr-0" (click)="addExpense()" *ngIf="mode != 'VIEW' && index==0">
                        <i class="pi pi-plus"></i>
                    </span>
                    <span class="btnBars p-mr-0" (click)="openProducts()" *ngIf="mode != 'VIEW' && index==1">
                        <i class="pi pi-plus"></i>
                    </span>
                </ng-template>
            </p-tabPanel>
        </p-tabView>
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12"
                *ngIf="billTemplate && billTemplate.labels_message  && billTemplate.labels_message[0]?.isChecked">
                <p-editor #editor placeholder="Memo" [style]="{'height':'50px'}" formControlName="notes"></p-editor>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="closeDialog()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton class="p-button-success" [disabled]="(isAllowPostingPeriod && !updatedPostingPeriodInfo?.postingDate) || billForm.controls['amountDue'].value == 0 || shipAddress==null 
             || mode == 'VIEW' || isDisabled || (!!statementMessege && savedBill?.netAmount != amountItem) 
             || (!!statementMessege && savedBill?.totalExpenseAmount != amountExpense)
             || (expenses?.length==0 && items?.length==0)" label="Save" (click)="updateBill(billForm.value)"></button>
    </p-footer>
</p-dialog>

<p-dialog header="{{expenseHeader}}" [(visible)]="displayAddExpense" [modal]="true" [responsive]="true"
    [closable]="false" [style]="{width: '60vw'}" (onHide)="accountForm.reset();">
    <form [formGroup]="accountForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Finance Account</label>
                    <liono-treeSelect class="border-bottom-input" [options]="financialAccounts" appendTo="body"
                        placeholder="Select Financial Account" formControlName="financialAccountId" display="comma"
                        [metaKeySelection]="false" selectionMode="single"></liono-treeSelect>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Amount</label>
                    <p-inputNumber mode="decimal" [minFractionDigits]="length" [maxFractionDigits]="length"
                        formControlName="amount" [min]="0"></p-inputNumber>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <label>Memo</label>
                    <textarea rows="5" cols="30" pInputTextarea formControlName="memo"></textarea>
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="displayAddExpense = false;" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" pButton class="p-button-success" label="Save" [disabled]="!accountForm.valid"
            (click)="saveExpense(accountForm.value)"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Select Vendor Address" [(visible)]="displayVendorAddress" [modal]="true" [responsive]="true"
    [closable]="false" [style]="{ width: '80vw' }" [baseZIndex]="9999">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p-table [value]="selectedVendorDD?.vendorAddresses" [(selection)]="selectedVendorAddress" dataKey="id"
                    (onRowSelect)="onRowSelectAddress($event)" selectionMode="single">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Type</th>
                            <th>Street 1</th>
                            <th>Street 2</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Country</th>
                            <th>Zipcode</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-address>
                        <tr [pSelectableRow]="address">
                            <td>{{address.address?.addressType?.name }}</td>
                            <td>{{address.address?.streetAddress1 }}</td>
                            <td>{{address.address?.streetAddress2 }}</td>
                            <td>{{address.address?.city?.name }}</td>
                            <td>{{address.address?.city?.state?.name }}</td>
                            <td>{{address.address?.country?.name}}</td>
                            <td>{{address.address?.zipCode}}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayVendorAddress = false" label="Cancel"
            class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Select Vendor Contact" [(visible)]="displayVendorContact" [modal]="true" [responsive]="true"
    [closable]="false" [style]="{ width: '80vw' }" [baseZIndex]="9999">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p-table [value]="vendorDetails?.vendorContacts" [(selection)]="selectedVendorContact" dataKey="id"
                    (onRowSelect)="onRowSelectContact()" selectionMode="single">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Primary Contact</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-contact>
                        <tr [pSelectableRow]="contact" *ngIf="contact.statusId==1">
                            <td>{{contact.contact?.isPrimaryContact?'Yes':'No'}}</td>
                            <td>{{contact.contact?.firstName}} {{contact.contact?.lastName}}</td>
                            <td>{{contact.contact?.contactEmails.length>0 ?
                                contact.contact?.contactEmails[0].email?.emailAddress:''}}
                            </td>
                            <td>{{contact.contact?.contactPhones.length>0 ?
                                contact.contact?.contactPhones[0].phone?.number:''}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayVendorContact = false" label="Cancel"
            class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Products Lists" [(visible)]="displayProductsTb" [modal]="true" [responsive]="true" [closable]="false"
    [style]="{width: '80vw'}"
    (onHide)="isBundle=false;selectedBundle=null;selectedProductsList=[];productGlobalFilterInput=null;searchValue=null;">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p-table #products [columns]="productsTBCol" [value]="productsTB" [(selection)]="selectedProductsList"
                    dataKey="productId" selectionMode="multiple" [lazy]="true" [totalRecords]="totalTBRecord"
                    [rows]="pageSize" [paginator]="true" (onPage)="getTBData($event)" [first]="first"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                    <ng-template pTemplate="caption">
                        <div class="table-header p-px-0 p-grid" style="background-color: #ddd;">
                            <div class="p-col-12 p-md-3 p-mt-2">
                                <p-dropdown [options]="productChannels" id="productChannels"
                                    [(ngModel)]="selectedTBChannel" optionLabel="name" appendTo="body"
                                    (onChange)="changeTBChannel()"></p-dropdown>
                            </div>
                            <div class="p-col-12 p-md-6 p-mt-2">
                                <span class="p-input-icon-left" style="width: 100%;">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text" [(ngModel)]="productGlobalFilterInput"
                                        (ngModelChange)="onTableChanged($event)" placeholder="Search..." />
                                </span>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <ng-container *ngFor="let col of columns">
                                <th *ngIf="col.show && col.field == 'description' && col.field != 'isTrackingRequired'" style="width: 300px;">
                                    {{col.header}}
                                </th>
                                <th *ngIf="col.show && col.field != 'description' && col.field != 'isTrackingRequired'">
                                    {{col.header}}
                                </th>
                                <th *ngIf="col.show && col.field == 'isTrackingRequired' && selectedTBChannel?.name=='Inventory Item'">
                                    {{col.header}}
                                </th>
                            </ng-container>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
                            <ng-container *ngFor="let col of columns">
                                <td *ngIf="col.show  && col.field!='description' && col.field!='isTrackingRequired'">
                                    <span *ngIf="col.field=='price'">{{rowData[col.field] | multicurrency:
                                        (vendorExchangeRate ??
                                        baseCurrency?.exchangeRate):(vendorDetails?.currencyUnit?.symbol ??
                                        baseCurrency?.symbol):length}}</span>
                                    <span *ngIf="col.field!='price'">{{rowData[col.field]}}</span>
                                </td>
                                <td *ngIf="col.field=='description'">{{rowData[col.field] | shorten: 55}}</td>
                                <td *ngIf="col.show && col.field == 'isTrackingRequired' && selectedTBChannel?.name=='Inventory Item'">
                                    {{rowData[col.field]}}
                                </td>
                            </ng-container>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="12">
                                <div class="p-text-center">{{noCaseFindOrLoadingText}}</div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>

    <p-footer>
        <button type="button" pButton (click)="displayProductsTb = false" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" pButton label="Add" (click)="addProduct()"
            [disabled]="selectedProductsList?.length == 0"></button>
    </p-footer>
</p-dialog>

<!-- Tracking Information -->
<p-dialog header="Tracking Information" [(visible)]="displayScanInfo" [modal]="true" [responsive]="true"
    [closable]="true" [style]="{ width: '70vw' }" (onHide)="trackingForm.reset();savedOptionSelection=null;">
    <form [formGroup]="trackingForm">
        <div class="card">
            <div class="p-grid" *ngIf="mode != 'VIEW'">
                <div class="p-col-12 p-lg-2">
                    <div class="p-d-flex p-jc-between w-100">
                        <label>Qty<span style="color: red;">*</span></label>
                        <label>{{listLength}} / {{selectedProductForScan?.availabel}}</label>
                    </div>
                    <input pInputText type="text" id="lot" name="lot" formControlName="qty" onlyNumber />
                </div>
                <div class="p-col-12 p-lg-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'lotChecked',savedOptionSelection)">
                    <label>{{utilService.displayName('lotChecked',trackingOptions,'label')}}<span style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('lotChecked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('lotChecked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText type="text" id="lot" name="lot" formControlName="lotNo" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" onlyNumber id="lot" name="lot" formControlName="lotNo" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="lotNo"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" appDecimalNumber id="lot" name="lot" formControlName="lotNo"
                                [length]="utilService.getDecimalValue(trackingOptions,'lotChecked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-lg-4"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'revisionChecked',savedOptionSelection)">
                    <label>{{utilService.displayName('revisionChecked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('revisionChecked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('revisionChecked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText type="text" id="revision" name="revision" formControlName="revisionNo" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" onlyNumber id="revision" name="revision"
                                formControlName="revisionNo" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="revisionNo"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" id="revision" name="revision" formControlName="revisionNo"
                                appDecimalNumber
                                [length]="utilService.getDecimalValue(trackingOptions,'revisionChecked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-lg-4"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'expirationChecked',savedOptionSelection)">
                    <label>{{utilService.displayName('expirationChecked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('expirationChecked',trackingOptions)">*</span></label>
                    <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                        dateFormat="mm/dd/yy" yearRange="1900:2100" [minDate]="minimumDate"
                        formControlName="expiration">
                    </p-calendar>
                </div>
            </div>
            <div *ngIf="mode != 'VIEW'">
                <hr />
            </div>
            <div class="p-field p-formgrid p-grid" *ngIf="mode != 'VIEW'">
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serializedChecked',savedOptionSelection)">
                    <label>{{utilService.displayName('serializedChecked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serializedChecked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serializedChecked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'Decimal'">
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo"
                                appDecimalNumber (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serializedChecked')" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" onlyNumber name="number" id="number"
                                formControlName="serialNo" (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText name="number" id="number" formControlName="serialNo"
                                (keydown.enter)="countNameList(trackingForm.value)" [readonly]="isAutoGenerated">
                            <div *ngIf="trackingForm.controls['serialNo'].invalid && (trackingForm.controls['serialNo'].dirty || trackingForm.controls['serialNo'].touched)"
                                class="p-invalid">
                                <div *ngIf="trackingForm.controls['serialNo'].errors.pattern">
                                    Only alphanumeric characters are allowed.
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial2Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial2Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial2Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial2Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo2"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" onlyNumber name="number" id="number"
                                formControlName="serialNo2" (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo2"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo2"
                                appDecimalNumber (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial2Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial3Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial3Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial3Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial3Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo3"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" onlyNumber name="number" id="number"
                                formControlName="serialNo3" (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo3"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo3"
                                appDecimalNumber (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial3Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial4Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial4Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial4Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial4Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo4"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo4"
                                onlyNumber (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo4"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo4"
                                appDecimalNumber (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial4Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial5Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial5Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial5Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial5Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo5"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" onlyNumber name="number" id="number"
                                formControlName="serialNo5" (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo5"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" appDecimalNumber name="number" id="number"
                                formControlName="serialNo5" (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial5Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial6Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial6Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial6Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial6Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo6"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" name="number" onlyNumber id="number"
                                formControlName="serialNo6" (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo6"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo6"
                                appDecimalNumber (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial6Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial7Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial7Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial7Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial7Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo7"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo7"
                                onlyNumber (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo7"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" name="number" appDecimalNumber id="number"
                                formControlName="serialNo7" (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial7Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial8Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial8Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial8Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial8Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo8"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo8"
                                onlyNumber (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo8"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo8"
                                appDecimalNumber (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial8Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial9Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial9Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial9Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial9Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo9"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo9"
                                onlyNumber (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo9"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo9"
                                appDecimalNumber (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial9Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial10Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial10Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial10Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial10Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo10"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo10"
                                onlyNumber (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo10"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo10"
                                appDecimalNumber (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial10Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial11Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial11Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial11Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial11Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo11"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo11"
                                onlyNumber (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo11"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo11"
                                appDecimalNumber (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial11Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial12Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial12Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial12Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial12Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo12"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" name="number" onlyNumber id="number"
                                formControlName="serialNo12" (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo12"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo12"
                                appDecimalNumber (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial12Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial13Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial13Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial13Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial13Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo13"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo13"
                                onlyNumber (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo13"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" name="number" appDecimalNumber id="number"
                                formControlName="serialNo13" (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial13Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial14Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial14Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial14Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial14Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo14"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo14"
                                onlyNumber (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo14"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" name="number" appDecimalNumber id="number"
                                formControlName="serialNo14" (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial14Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial15Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial15Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial15Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial15Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo15"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo15"
                                onlyNumber (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo15"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo15"
                                appDecimalNumber (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial15Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial16Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial16Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial16Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial16Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo16"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo16"
                                onlyNumber (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo16"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo16"
                                appDecimalNumber (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial16Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2"
                    *ngIf="utilService.showTrackingOption(trackingOptions,'serial17Checked',savedOptionSelection)">
                    <label>{{utilService.displayName('serial17Checked',trackingOptions,'label')}}<span
                            style="color: red;"
                            *ngIf="utilService.checkRequiredValidation('serial17Checked',trackingOptions)">*</span></label>
                    <ng-container [ngSwitch]="utilService.displayName('serial17Checked',trackingOptions,'control')">
                        <ng-container *ngSwitchCase="'InputBox'">
                            <input pInputText name="number" id="number" formControlName="serialNo17"
                                (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'Number'">
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo17"
                                onlyNumber (keydown.enter)="countNameList(trackingForm.value)" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'DatePicker'">
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                formControlName="serialNo17"></p-calendar>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input pInputText type="text" name="number" id="number" formControlName="serialNo17"
                                appDecimalNumber (keydown.enter)="countNameList(trackingForm.value)"
                                [length]="utilService.getDecimalValue(trackingOptions,'serial17Checked')" />
                        </ng-container>
                    </ng-container>
                </div>
                <div class="p-col-12 p-md-2">
                    <button type="button" pButton label="Add" class="p-mt-5 p-ml-2"
                        [disabled]="!trackingForm.valid || listLength == selectedProductForScan?.availabel"
                        (click)="countNameList(trackingForm.value)"></button>
                    <button type="button" pButton icon="pi pi-download" (click)="openImport()" class="p-mt-5 p-ml-3"
                        pTooltip="Import SerialNo"></button>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <p-table [value]="nameLists" class="w-100" [lazy]="true" [paginator]="true" [first]="first"
                    [totalRecords]="totalTBRecord" [rows]="pageSize" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="rowsPerPageTB" (onPage)="loadSerialsLazy($event)">
                    <ng-template pTemplate="header">
                        <tr>
                            <th id="lot"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'lotChecked',savedOptionSelection)">
                                {{utilService.displayName('lotChecked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('lotChecked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('lotChecked',trackingOptions,'control')=='Currency'">({{utilService.displayName('lotChecked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="revision"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'revisionChecked',savedOptionSelection)">
                                {{utilService.displayName('revisionChecked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('revisionChecked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('revisionChecked',trackingOptions,'control')=='Currency'">({{utilService.displayName('revisionChecked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="date"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'expirationChecked',savedOptionSelection)">
                                {{utilService.displayName('expirationChecked',trackingOptions,'label')}}
                            </th>
                            <th id="serialNo"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serializedChecked',savedOptionSelection)">
                                {{utilService.displayName('serializedChecked',trackingOptions,'label')}}</th>
                            <th id="serialNo2"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial2Checked',savedOptionSelection)">
                                {{utilService.displayName('serial2Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial2Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial2Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial2Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="serialNo3"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial3Checked',savedOptionSelection)">
                                {{utilService.displayName('serial3Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial3Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial3Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial3Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="serialNo4"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial4Checked',savedOptionSelection)">
                                {{utilService.displayName('serial4Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial4Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial4Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial4Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="serialNo5"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial5Checked',savedOptionSelection)">
                                {{utilService.displayName('serial5Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial5Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial5Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial5Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="serialNo6"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial6Checked',savedOptionSelection)">
                                {{utilService.displayName('serial6Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial6Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial6Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial6Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="serialNo7"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial7Checked',savedOptionSelection)">
                                {{utilService.displayName('serial7Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial7Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial7Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial7Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="serialNo8"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial8Checked',savedOptionSelection)">
                                {{utilService.displayName('serial8Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial8Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial8Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial8Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="serialNo9"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial9Checked',savedOptionSelection)">
                                {{utilService.displayName('serial9Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial9Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial9Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial9Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="serialNo10"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial10Checked',savedOptionSelection)">
                                {{utilService.displayName('serial10Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial10Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial10Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial10Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="serialNo11"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial11Checked',savedOptionSelection)">
                                {{utilService.displayName('serial11Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial11Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial11Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial11Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="serialNo12"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial12Checked',savedOptionSelection)">
                                {{utilService.displayName('serial12Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial12Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial12Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial12Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="serialNo13"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial13Checked',savedOptionSelection)">
                                {{utilService.displayName('serial13Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial13Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial13Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial13Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="serialNo14"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial14Checked',savedOptionSelection)">
                                {{utilService.displayName('serial14Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial14Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial14Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial14Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="serialNo15"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial15Checked',savedOptionSelection)">
                                {{utilService.displayName('serial15Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial15Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial15Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial15Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="serialNo16"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial16Checked',savedOptionSelection)">
                                {{utilService.displayName('serial16Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial16Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial16Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial16Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th id="serialNo17"
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial17Checked',savedOptionSelection)">
                                {{utilService.displayName('serial17Checked',trackingOptions,'label')}}
                                <span
                                    *ngIf="utilService.displayName('serial17Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                                <span
                                    *ngIf="utilService.displayName('serial17Checked',trackingOptions,'control')=='Currency'">({{utilService.displayName('serial17Checked',trackingOptions,'currency')}})</span>
                            </th>
                            <th style="width: 2rem">
                                <p-checkbox binary="true" [(ngModel)]="allChecked" (onChange)="setTableCheck()"
                                    [ngModelOptions]="{ standalone: true }"></p-checkbox>
                            </th>
                            <th style="width: 3rem" *ngIf="allChecked">
                                <span class="btnBars p-mt-0" (click)="deleteAll()">
                                    <i class="pi pi-trash" pTooltip="Delete All" tooltipPosition="top"></i>
                                </span>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-i="rowIndex">
                        <tr>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'lotChecked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName('lotChecked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.lotNo }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.lotNo && product.lotNo |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'revisionChecked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'revisionChecked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.revisionNo }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.revisionNo &&
                                        product.revisionNo |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'expirationChecked',savedOptionSelection)">
                                {{product.expiration | date: 'MM/dd/yyyy'}}
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serializedChecked',savedOptionSelection)">
                                {{
                                product.serialNo }}</td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial2Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial2Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo2 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo2 &&
                                        product.serialNo2 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial3Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial3Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo3 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo3 &&
                                        product.serialNo3 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial4Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial4Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo4 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo4 &&
                                        product.serialNo4 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial5Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial5Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo5 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo5 &&
                                        product.serialNo5 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial6Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial6Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo6 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo6 &&
                                        product.serialNo6 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial7Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial7Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo7 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo7 &&
                                        product.serialNo7 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial8Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial8Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo8 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo8 &&
                                        product.serialNo8 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial9Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial9Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo9 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo9 &&
                                        product.serialNo9 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial10Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial10Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo10 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo10 &&
                                        product.serialNo10 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial11Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial11Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo11 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo11 &&
                                        product.serialNo11 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial12Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial12Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo12 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo12 &&
                                        product.serialNo12 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial13Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial13Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo13 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo13 &&
                                        product.serialNo13 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial14Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial14Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo14 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo14 &&
                                        product.serialNo14 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial15Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial15Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo15 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo15 &&
                                        product.serialNo15 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial16Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial16Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo16 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo16 &&
                                        product.serialNo16 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td
                                *ngIf="utilService.showTrackingOption(trackingOptions,'serial17Checked',savedOptionSelection)">
                                <ng-container
                                    *ngIf="utilService.displayName( 'serial17Checked',trackingOptions,'control') as controlType">
                                    <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo17 }}</span>
                                    <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo17 &&
                                        product.serialNo17 |
                                        date:
                                        'MM/dd/yyyy' }}</span>
                                </ng-container>
                            </td>
                            <td>
                                <p-checkbox [value]="product" (onChange)="setMainHeaderTracking()"
                                    [(ngModel)]="product.checked" [ngModelOptions]="{ standalone: true }"
                                    binary="true"></p-checkbox>
                            </td>
                            <td class="action">
                                <span class="btnBars p-mt-0" *ngIf="product.checked == true" (click)="removeNumber(i)">
                                    <i class="pi pi-trash"></i>
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </form>
    <p-footer *ngIf="mode != 'VIEW'">
        <div style="float: left;">
            <div class="p-d-flex">
                <div class="p-d-flex" style="width: 40%;">
                    <p-checkbox [(ngModel)]="isPrefix" [binary]="true" (onChange)="prefixValue=''"></p-checkbox>
                    <input class="p-mx-2" type="text" [disabled]="!isPrefix" placeholder="Prefix" pInputText
                        [(ngModel)]="prefixValue" maxlength="5">
                </div>
                <div class="p-d-flex">
                    <p-checkbox [(ngModel)]="isAutoGenerated" [binary]="true"></p-checkbox>
                    <div class="p-ml-2 p-mt-2">Auto Generated</div>
                </div>
                <div class="p-d-flex p-ml-2 p-mt-2">
                    <button type="button" pButton [disabled]="!isPrefix || !isAutoGenerated" class="p-button-success"
                        label="Generate" (click)="generate()"></button>
                </div>
            </div>
        </div>
        <button type="button" pButton (click)="displayScanInfo = false" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" pButton (click)="saveSerializedNo(trackingForm.value)" class="p-button-success"
            label="Save"></button>
    </p-footer>
</p-dialog>

@if(displayImport){
<app-shared-import-series headerTitle="New Import" [display]="displayImport" [trackingOptions]="trackingOptions"
    [importForAllProducts]="false" [fromPO]="false" [importCount]="importCount" [trackingJSON]="savedOptionSelection"
    [hideBulkScan]="true" [disabledSave]="disabledSave" [savedData]="autoGenerateLists" (cancelClicked)="hideImport()"
    (onSave)="saveImport($event)"></app-shared-import-series>
}

<!-- tax selection dialog -->
@if(displayTaxSelectionDialog){
<app-tax-selection [visible]="displayTaxSelectionDialog" [taxes]="allTaxRates" [selectedTax]="selectedTax"
    (onApply)="applyTax($event)" (onClose)="onCloseTaxSelectionDialog($event)">
</app-tax-selection>
}

<!-- closing statement -->
@if(displayNewBill){
<app-closing-statement-validation 
  [isClosingDate]="isAllowPostingPeriod ? (updatedPostingPeriodInfo?.postingDate ?? currentPostingPeriodInfo?.postingDate ?? null) : billForm?.controls?.billDate?.value"
  [moduleName]="'Bill'" (isClosingStatementDate)="isClosingStatementDate($event)">
</app-closing-statement-validation>
}

@if(mode == 'PRINT' || mode == 'EMAIL'){
<app-billing-print [billPrintDetails]="billPrintDetails" [length]="length" [companyInfo]="companyInfo" [qtyDecimal]="qtyDecimal"
    [baseCurrency]="baseCurrency" [billTemplate]="billTemplate" [footerTaxEnabled]="footerTaxEnabled"></app-billing-print>
}

@if(displayNewEmail){
<app-send-email [displayNewEmail]="displayNewEmail" [header]="emailDialogHeader" [emailTo]="emailTo"
    [subject]="emailSubject" [content]="emailContent" [emailAttachments]="emailAttachments" [objectId]="vendorObjectId"
    [objectTypeId]="savedBill?.vendorId" (onSendComplete)="onEmailSendComplete($event)"
    (onCancel)="onEmailCancel($event)"></app-send-email>
}